import PropTypes  from "prop-types"
import * as React from "react"
import _          from "lodash"

class PPIFormComponent extends React.Component {
	render() {
		const ids     = {
			prospLength: "ppi-prosp-length",
			fctva: "ppi-fctva",
			fctvaRetrieve: "ppi-fctva-retrieve",
			thirsParties: "ppi-third-parties"
		}

		return (
			<div>
				<form onSubmit={this.props.onSubmit}>
					<header className="hero">
						<div className="hero-body">
							<div className="level">
								<div className="level-left">
									<div>
										<h2 className="title">Configuration du PPI Général</h2>
									</div>
								</div>
							</div>
						</div>
					</header>

					<div className="columns is-desktop">
						<div className="column is-three-fifths-desktop">

							<div className="field is-horizontal">
								<div className="field-label is-normal">
									<label className="label" htmlFor={ids.prospLength}>Nombre d'années de projection</label>
								</div>
								<div className="field-body">
									<div className="field">
										<div className={`control ${this.props.submitting ? "is-loading" : ""}`}>
											<input
											className   = "input"
											disabled    = {this.props.submitting}
											id          = {ids.prospLength}
											name        = "prospLength"
											placeholder = "6"
											type        = "number"
											required />
										</div>
									</div>
								</div>
							</div>

							<div className="field is-horizontal">
								<div className="field-label is-normal">
									<label className="label" htmlFor={ids.fctva}>Taux du FCTVA (en %)</label>
								</div>
								<div className="field-body">
									<div className="field">
										<div className={`control ${this.props.submitting ? "is-loading" : ""}`}>
											<input
											className   = "input"
											disabled    = {this.props.submitting}
											id          = {ids.fctva}
											name        = "fctva"
											placeholder = "16.4"
											step				= "0.1"
											type        = "number"
											required />
										</div>
									</div>
								</div>
							</div>

							<div className="field is-horizontal">
								<div className="field-label is-normal">
									<label className="label" htmlFor={ids.fctvaRetrieve}>Récupération du FCTVA</label>
								</div>
								<div className="field-body">
									<div className="field">
										<div className="control">
											<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
												<select
												defaultValue = ""
												disabled     = {this.props.submitting}
												id           = {ids.fctvaRetrieve}
												name         = "fctvaRetrieve"
												required>
													<option value="0">N</option>
													<option value="1">N+1</option>
													<option value="2">N+2</option>
												</select>
											</span>
										</div>
									</div>
								</div>
							</div>

							<div className="field is-horizontal">
								<div className="field-label is-normal">
									<label className="label" htmlFor={ids.thirdParties}>Opération pour compte de tiers ?</label>
								</div>
								<div className="field-body">
									<div className="field">
										<div className="control">
											<span className={`select is-fullwidth ${this.props.submitting ? "is-loading" : ""}`}>
												<select
												defaultValue = ""
												disabled     = {this.props.submitting}
												id           = {ids.thirdParties}
												name         = "thirdParties"
												required>
													<option value="true">Oui</option>
													<option value="false">Non</option>
												</select>
											</span>
										</div>
									</div>
								</div>
							</div>

							<button
								className={`button is-primary ${this.props.submitting ? "is-loading" : ""}`}
								disabled={this.props.submitting}>
								Créer
							</button>

						</div>
					</div>
				</form>
			</div>
		)
	}
}

PPIFormComponent.propTypes = {
	onSubmit     : PropTypes.func.isRequired,
	submitting   : PropTypes.bool.isRequired,
}

export default PPIFormComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-form/ppi-form-component.js